import { UserApi } from "@vintecc/capture-api-types/v1";
import captureApiConfiguration from "./configuration.api";

const user = new UserApi(captureApiConfiguration);

export default user;
